export default "__VITE_ASSET__KL7tOxKs__";